import * as semver from 'semver'

const CREATE_1155_PREMINT_V2_VERSION = '2.5.0'

export const contractSupportsPremintV2 = (
  contractVersion?: string | null,
  contractStandard: 'ERC721' | 'ERC1155' = 'ERC1155'
) => {
  if (!contractStandard || !contractVersion) {
    return false
  }

  // Try force-convert version format to semver format
  const semVerContractVersion = semver.coerce(contractVersion)?.raw
  if (!semVerContractVersion) return false

  if (contractStandard === 'ERC721') {
    // No ERC721 contracts support premint currently
    return false
  } else {
    return semver.gte(semVerContractVersion, CREATE_1155_PREMINT_V2_VERSION)
  }
}
